import { makeAutoObservable } from 'mobx'

export class ErrorBag {
  set(name, arg1) {
      this._validation_data.set(name, arg1)
  }


  /** @type ErrorBag|null */
  static instance = null;
  static getInstance() {
    if (!ErrorBag.instance) {
      ErrorBag.instance = new ErrorBag()
    }
    return ErrorBag.instance
  }




  _validation_data = new Map()
  _validation_elements = new Map()


  constructor () {
    makeAutoObservable(this)
  }

  getError (name) {
    return this._validation_data.get(name)?.error
  }

  hasError (name) {
    return (this._validation_data.get(name)?.error ?? '') !== ''
  }
  register(id, el) {
    this._validation_elements.set(id, el)
  }
  getFieldsWithErrors() {
    let returnValue = []
    for (const [key, value] of this._validation_data) {
      if (value.valid === true) {
        continue;
      }
      let element = this._validation_elements.get(key)
      if (element?.current) {
        returnValue.push(element.current)
      }
    }
    return returnValue
  }
  resetValidation(key = null) {

    if (key) {
      this._validation_data.delete(key)
    } else {
      this._validation_data.clear()
    }
  }
}